// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3wkwQ","signatureBlock":"Footer_signatureBlock__Y-WI0","signature":"Footer_signature__31asf"};